var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReorder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09091 2.5H22.9091C23.5116 2.5 24 1.94036 24 1.25C24 0.559644 23.5116 0 22.9091 0H1.09091C0.488417 0 0 0.559644 0 1.25C0 1.94036 0.488417 2.5 1.09091 2.5Z",
    fill: "#3030AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 8H1.09091C0.488417 8 0 8.55964 0 9.25C0 9.94036 0.488417 10.5 1.09091 10.5H22.9091C23.5116 10.5 24 9.94036 24 9.25C24 8.55964 23.5116 8 22.9091 8Z",
    fill: "#3030AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 16H1.09091C0.488417 16 0 16.5596 0 17.25C0 17.9404 0.488417 18.5 1.09091 18.5H22.9091C23.5116 18.5 24 17.9404 24 17.25C24 16.5596 23.5116 16 22.9091 16Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReorder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reorder.2877ef18f491f70cb19815fe2f889312.svg";